module.exports = __webpack_public_path__ + "media/front/images/drawing-0e9cff49f2887ccff3b41b2c4ebe290e.svg";